export default [
    {
        meta: {
            title: 'Задачи',
            permissions: "take_tasks",
            states: ["atWork", "!atLunch"]

        },
        path: 'new',
        name: 'tasks-new',
        component: () => import('@/views/tasks/NewTasksList.vue')
    },
    {
        meta: {
            title: 'Задачи',
        },
        path: 'completed',
        name: 'tasks-completed',
        component: () => import('@/views/tasks/CompletedTasksList.vue')
    },
    {
        meta: {
            title: 'Задачи',
        },
        path: 'pending-checks',
        name: 'tasks-pending-checks',
        component: () => import('@/views/tasks/PendingChecksTasksList.vue')
    },
]